import { getAuth, onIdTokenChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import RefreshAuth from "./refreshAuth";

const VerifyAuth = () => {
  const auth = getAuth();
  const [isLoggedin, setIsLoggedin] = useState(null);

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(auth, (user) => {
      if (user) {
        RefreshAuth(user);
        setIsLoggedin(true);
      } else {
        ["userName", "userEmail", "profImg", "newUser"].forEach((k) =>
          localStorage.removeItem(k),
        );
        Cookies.remove("token");
        Cookies.remove("userId");
        setIsLoggedin(false);
      }
    });
    return unsubscribe;
  }, [auth]);
  return isLoggedin;
};

export default VerifyAuth;
